import createClient from 'openapi-fetch'
import type { components, paths } from './gen/ledger'
import { authFetch, call } from './http'

export type LedgerSchemas = components['schemas']
export type Money = LedgerSchemas['Money']
export type Account = LedgerSchemas['Account']
export type Transaction = LedgerSchemas['Transaction']
export type Rule = LedgerSchemas['Rule']
export type Import = LedgerSchemas['Import']
export type TxQuery = NonNullable<paths['/transactions']['get']['parameters']['query']>
/** Filter-bar state: every field optional, blank strings allowed. */
export type TxFilter = { [K in keyof TxQuery]?: TxQuery[K] | '' }

const origin = typeof location !== 'undefined' ? location.origin : 'http://localhost'

export const ledger = createClient<paths>({ baseUrl: `${origin}/api/ledger`, fetch: authFetch })

/** Filter-bar state → query: blank fields dropped, cursor added when paging. */
export function txQuery(filter: TxFilter, cursor?: string, limit = 50): TxQuery {
  const q = Object.fromEntries(Object.entries(filter).filter(([, v]) => v !== '' && v != null)) as TxQuery
  return { ...q, ...(cursor ? { cursor } : {}), limit }
}

export const listTransactions = (filter: TxFilter, cursor?: string) =>
  call(ledger.GET('/transactions', { params: { query: txQuery(filter, cursor) } }))

/** Multipart upload; the FormData body lets the browser set the boundary Content-Type. */
export function importStatement(file: File, accountId: string) {
  const fd = new FormData()
  fd.append('account_id', accountId)
  fd.append('file', file)
  return call(ledger.POST('/imports', { body: { file: '', account_id: accountId }, bodySerializer: () => fd }))
}
